import { render } from "./HomePain.vue?vue&type=template&id=56c9b431&scoped=true"
import script from "./HomePain.vue?vue&type=script&lang=js"
export * from "./HomePain.vue?vue&type=script&lang=js"

import "./HomePain.vue?vue&type=style&index=0&id=56c9b431&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c9b431"]])

export default __exports__